export default "/react/logoGoodKey-90b6a0e6.png";